<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-index="index" let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps) {
		@if (instruction.pressureMode !== null) { <app-instruction-box>{{ pressureMode[index] }}</app-instruction-box> }
		@if (instruction.pressureSetting) { <app-instruction-box>{{ instruction.pressureSetting.quantity }} {{ instruction.pressureSetting.unit }}</app-instruction-box> }
	}
</ng-template>